<ng-container *ngIf="loading && items.length == 0">
    <div class="content-centered-column">
        <div class="content-centered-row">
            <ion-spinner></ion-spinner>
        </div>
    </div>
</ng-container>

<div class="list"
     infiniteScroll
     [infiniteScrollDisabled]="loading"
     [infiniteScrollDistance]="2"
     [infiniteScrollThrottle]="150"
     [scrollWindow]="false"
     [alwaysCallback]="true"
     (scrolled)="loadData($event)">

     <ion-searchbar *ngIf="items.length > 5 || searchTerm"
                    [placeholder]="'ATTENDEE_LIST_SEARCH_PLACEHOLDER' | translate"
                    class="without-border"
                    style="padding: 0;"
                    [debounce]="500"
                    enterkeyhint="search"
                    [(ngModel)]="searchTerm"
                    (onenter)="refresh()"
                    (ionChange)="refresh(null, true)">
     </ion-searchbar>

    <div *ngFor="let item of items; let c = index"
         class="participant"
         [ngClass]="{'admin': item.is_owner || item.is_moderator}">
        <ion-avatar (click)="showAttendeeDetail(item)">
            <img class="avatar"
                 img-avatar
                 [src]="user?.canPicture(item) ? item.picture_url : ''"
                 alt="">
        </ion-avatar>

        <div class="detail">
            <h3 (click)="showAttendeeDetail(item)">{{ item.firstname }} {{ item.lastname }}</h3>

            <ion-chip *ngIf="item.is_owner"
                      class="role owner">
                <ion-label>{{ 'CHAT_GROUP_ROLE_OWNER' | translate }}</ion-label>
            </ion-chip>

            <ion-chip *ngIf="item.is_moderator"
                      class="role moderator">
                <ion-label>{{ 'CHAT_GROUP_ROLE_MODERATOR' | translate }}</ion-label>
            </ion-chip>

            <a *ngIf="(chatGroup.user_is_owner || chatGroup.user_is_moderator) && !chatGroup.appointment_id"
                 class="action-buttons">
                <svg-icon [applyClass]="true"
                          src="/assets/icons/ico-settings.svg"
                          class="remove"
                          (click)="showActionMenu($event, item)"></svg-icon>

            </a>
            <!-- <div *ngIf="(chatGroup.user_is_owner || chatGroup.user_is_moderator) && item.user_id != chatGroup.user_id"
                 class="action-buttons">

                 <ng-container *ngIf="!filterInvited">
                     <svg-icon [applyClass]="true"
                               src="/assets/icons/ico-close.svg"
                               class="remove"
                               (click)="openDestroyParticipant(item)"></svg-icon>
                 </ng-container>

                 <ng-container *ngIf="filterInvited">
                     <svg-icon [applyClass]="true"
                               src="/assets/icons/ico-mail.svg"
                               class="invite"
                               (click)="invite(item)"></svg-icon>
                   <svg-icon [applyClass]="true"
                             src="/assets/icons/ico-close.svg"
                             class="remove"
                             (click)="cancelInvitation(item)"></svg-icon>
                 </ng-container>

            </div>
            <div *ngIf="chatGroup.user_is_owner"
                class="action-buttons">
                <svg-icon [applyClass]="true"
                          src="/assets/icons/ico-close.svg"
                          class="remove"
                          [title]="'CHAT_GROUP_MEMBER_DELETE_TITLE' | translate"
                          (click)="openDestroyParticipant(item)"></svg-icon>
            </div> -->
        </div>
    </div>
</div>
